import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { usePostHog } from 'posthog-js/react';

export const BUTTON_VARIANTS = {
    REVERSE: 'button-reverse',
    DARKEN: 'button-darken',
    CLEAR: 'button-clear',
    OUTLINE: 'button-outline',
    CTA: 'button-cta',
    CTA_LIGHT: 'button-cta-light',
    PINK_GRADIENT: 'button-pink-gradient',
    DANGER: 'button-danger',
    DARK: 'button-dark',
    GRAY: 'button-gray',
    DARK_PRIMARY: 'button-dark-primary',
    OVER_DARK: 'button-over-dark',
    // primary: 'button-primary',
    // secondary: 'button-secondary',
    // tertiary: 'button-tertiary',
    // danger: 'button-danger',
    // link: 'button-link',
    // icon: 'button-icon',
};

const Button = ({ 
    children,
    trackingEvent,
    trackingProperties, 
    onClick,
    isLink, 
    isInput,
    isExternal,
    active, 
    disabled,
    loading,
    className,
    badge,
    variant,
    onlyIcon,
    small,
    medium,
    big,
    full,
    ...props 
}) => {
    const LinkTag = isExternal ? 'a' : Link;
    const Tag = isLink ? LinkTag : 'button';
    const posthog = usePostHog();
    
    const handleClick = (e) => {
        if (trackingEvent) posthog.capture(trackingEvent, trackingProperties || {});
        if (loading || disabled) {
            e.preventDefault();
            return;
        }
        if (typeof onClick === 'function') {
            onClick(e);
        }
    }
    if (isInput) {
        return (
            <label className={classNames('button-v3 button-file', className, variant, {active, disabled, onlyIcon, small,big,medium, full})}>
                <input {...props} onClick={handleClick} disabled={disabled || loading} />
                {loading && <div className="button-loading">
                    <FontAwesomeIcon className="button-loading-icon" icon={faSpinnerThird} spin />    
                </div>}
                {children}
                {badge && <span className="button-badge">{badge}</span>}
            </label>
        );
    }
    return (
        <Tag className={classNames('button-v3', className, variant, {active, disabled, onlyIcon, small,big,medium, full})} {...props} onClick={handleClick}>
            {loading && <div className="button-loading">
                <FontAwesomeIcon className="button-loading-icon" icon={faSpinnerThird} spin />    
            </div>}
            {children}
            {badge && <span className="button-badge">{badge}</span>}
        </Tag>
    );
};

export default Button;
